import React from 'react';

import { acimaDoTemaDx, styledDs as styled } from '../../../styles/theme';

const Cabecalho = styled.header`
  display: flex;
  align-items: flex-start;
  gap: ${({ theme }) => theme.space.md};
  flex: none;
`;

const Titulo = styled.h1`
  ${acimaDoTemaDx} {
    font-size: ${({ theme }) => theme.font.sizeXl};
    line-height: ${({ theme }) => theme.leading.h3};
    letter-spacing: ${({ theme }) => theme.tracking.titulo};
    font-weight: ${({ theme }) => theme.weight.bold};
    color: ${({ theme }) => theme.colors.textPrimary};
  }
`;

const Descricao = styled.p`
  margin-top: ${({ theme }) => theme.space.xs};
  font-size: ${({ theme }) => theme.font.sizeMd};
  line-height: 1.45;
  color: ${({ theme }) => theme.colors.textSecondary};
`;

const Acoes = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.space.sm};
`;

export type DsPageHeaderProps = {
  titulo: string;
  descricao?: string;
  acoes?: React.ReactNode;
};

/**
 * Cabeçalho padrão das telas. O título é o `h1` da página — cada tela tem
 * exatamente um, e o resto da hierarquia desce a partir dele.
 */
export const DsPageHeader: React.FC<DsPageHeaderProps> = ({ titulo, descricao, acoes }) => (
  <Cabecalho>
    <div>
      <Titulo>{titulo}</Titulo>
      {descricao && <Descricao>{descricao}</Descricao>}
    </div>
    {acoes && <Acoes>{acoes}</Acoes>}
  </Cabecalho>
);

/** Linha discreta com o total, no pé da lista. */
export const DsListCount = styled.p`
  flex: none;
  font-size: ${({ theme }) => theme.font.sizeXs};
  color: ${({ theme }) => theme.colors.textMuted};
`;
